// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty } from '@shared/commons/DynProperty';
import { OptionTraderUtils } from '@shared/commons/cache/OptionMaster/OptionTrader/OptionTraderUtils';
import { QuickTableComparingType } from '@shared/utils/QuickTableMisc/QuickTableComparingType';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class OptionVolatilityLabSeriesTableItem extends BaseItem {
    constructor(expirationDate, seriesLine, sessionSettings) {
        super(sessionSettings);
        this.expirationDate = expirationDate;
        this.seriesLine = seriesLine;
        this.QuickTableEditingInfoMap[OptionVolatilityLabSeriesTableItem.ACTIVE_COL_INDEX] = new QuickTableEditingInfo(DynProperty.BOOLEAN);
        const colorQuickTableEditingInfo = new QuickTableEditingInfo(DynProperty.COLOR);
        colorQuickTableEditingInfo.IsEditable = false;
        this.QuickTableEditingInfoMap[OptionVolatilityLabSeriesTableItem.COLOR_COL_INDEX] = colorQuickTableEditingInfo;
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        return new ColumnData(value, value.toString());
    }
    getColumnValue(column) {
        switch (column) {
            case OptionVolatilityLabSeriesTableItem.ACTIVE_COL_INDEX:
                return this.seriesLine.isActive;
            case OptionVolatilityLabSeriesTableItem.SERIES_COL_INDEX:
                return OptionTraderUtils.formatExpirationDate(this.expirationDate);
            case OptionVolatilityLabSeriesTableItem.COLOR_COL_INDEX:
                return this.seriesLine.color;
            default:
                return undefined;
        }
    }
    ColumnCount() {
        return OptionVolatilityLabSeriesTableItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = OptionVolatilityLabSeriesTableItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetDataType(columnIndex) {
        return OptionVolatilityLabSeriesTableItem.dataTypes[columnIndex];
    }
}
OptionVolatilityLabSeriesTableItem.ACTIVE_COL_INDEX = 0;
OptionVolatilityLabSeriesTableItem.SERIES_COL_INDEX = 1;
OptionVolatilityLabSeriesTableItem.COLOR_COL_INDEX = 2;
OptionVolatilityLabSeriesTableItem.columnsParams = [
    new ColumnParams('panel.optionVolatilityLab.active', 15, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.optionVolatilityLab.series', 85, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.optionVolatilityLab.color', 25, QTAlignment.Left, TableTotalsVisibility.None, true, false)
];
OptionVolatilityLabSeriesTableItem.dataTypes = [
    QuickTableComparingType.String,
    QuickTableComparingType.String,
    QuickTableComparingType.String
];
